import { ServiceMode } from 'generated/graphql-gateway';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useServiceModeContext } from 'state/service-mode';

export const useIsVehicleDescriptionEnabled = (): boolean => {
  const { serviceMode } = useServiceModeContext();
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );
  const isOrderBayEnabled = useFlag(LaunchDarklyFlag.ENABLE_ORDER_BAY);

  return (
    // TODO: BKPE-6812 ORDER_BAY_PILOT. Remove or consolidate this logic once the pilot is done
    !isOrderBayEnabled &&
    (serviceMode === ServiceMode.CURBSIDE ||
      (serviceMode === ServiceMode.DRIVE_THRU && isMobileOrderForDriveThruLaneEnabled) ||
      serviceMode === ServiceMode.MOBILE_ORDER_DRIVE_THRU)
  );
};
